export const distOptions = [
  "uniform",
  "triangular",
  "exponential",
  "poisson",
  "normal",
  "erlang",
];

// Which fields are editable per distribution.
export const distParams = {
  uniform: { min: true, max: true, arg3: null, arg4: null },
  triangular: { min: true, max: true, arg3: "mode", arg4: null },
  exponential: { min: false, max: false, arg3: "lambda", arg4: null },
  poisson: { min: false, max: false, arg3: "lambda", arg4: null },
  normal: { min: false, max: false, arg3: "mean", arg4: "std. deviation" },
  erlang: { min: false, max: false, arg3: "shape", arg4: "scale" },
};
